exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir=ltr] ._2a1AWYqR5U7BiFoxIQfcjZ{padding-left:5px}html[dir=rtl] ._2a1AWYqR5U7BiFoxIQfcjZ{padding-right:5px}html[dir] ._1jbo3aW9KTd6b_Wd1b11Qn{padding-top:19px}", ""]);
// Exports
exports.locals = {
	"timeSuggestionsExp": "_2a1AWYqR5U7BiFoxIQfcjZ",
	"composeRowExp": "_1jbo3aW9KTd6b_Wd1b11Qn"
};